import React, { useMemo, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel, faDownload } from "@fortawesome/free-solid-svg-icons";
import func from "../../services/functions";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import TooltipOverlay from "./TooltipOverlay";

const bigDecimal = require("js-big-decimal")

const ExportCsvPrime = ({ label = "Export", data, columns, selectedColumns, onClick, excludedColumns, callback,showAmount=false,tooltip, onExportComplete, iconOnly=false  }) => {

  const [loading, setLoading] = useState(false);
  const { t } = useTranslation("translations");
  const csvInstance = useRef(true)

  const totalPayKey = t("invoice.totalPay");
  const preventExcelFormatFn = (value, prevent) => {
    if (prevent) return "\t" + value
    return value
  }


  const exportColumns = useMemo(() => {
    if (!selectedColumns?.length) return columns ?? [];
    const ordered = [];
    selectedColumns.forEach((sCol) => {
      const col = columns?.find((c) => c.field === sCol?.field);
      if (col) ordered.push(col);
    });
    (columns ?? []).forEach((col) => {
      if (!ordered.includes(col)) ordered.push(col);
    });
    return ordered;
  }, [columns, selectedColumns]);

  let dataFormatted = [];
  if (data?.length > 0) {
    dataFormatted = data.map((invoice) => {
      const formattedObject = {};
      let amountALL = "0.00"
      if (showAmount) {amountALL= invoice.currency !== "ALL" ? (func.getFormattedMoneyValue(bigDecimal.multiply(invoice.rate, invoice.invoiceTotalWithVat))) : "0,00"}
      exportColumns.forEach((customInvoiceColumn) => {
        if (!excludedColumns?.find(excCol => excCol === customInvoiceColumn.field)) {
          if(showAmount){
            formattedObject[totalPayKey] = amountALL;
          }
          const bodyValue = customInvoiceColumn?.body? customInvoiceColumn.body(invoice):null
          const head=customInvoiceColumn?.exportHeader ?? customInvoiceColumn.header
          const { preventExcelFormat = false } = customInvoiceColumn

          if (customInvoiceColumn.format) {
            formattedObject[head] = preventExcelFormatFn(customInvoiceColumn.format(invoice),preventExcelFormat)
          }else if (customInvoiceColumn?.formattedExportValue) {
            formattedObject[head] = preventExcelFormatFn(bodyValue,preventExcelFormat)
          } else {
            formattedObject[head] = preventExcelFormatFn(invoice[customInvoiceColumn.field],preventExcelFormat)
          }
        }

      });
      if (callback !== undefined) {
        callback(invoice, formattedObject);
      }

      return formattedObject;
    })
  } else {
    const dummy = {};
    exportColumns.forEach((customInvoiceColumn) => {
      if (!excludedColumns?.find(excCol => excCol === customInvoiceColumn.field)) {
        const head=customInvoiceColumn?.exportHeader ?? customInvoiceColumn.header
        dummy[head] = null;
      }
    });
    dataFormatted = [dummy];
  }



  const onCsvClick = () => {
    if (!loading && csvInstance?.current?.link && onClick !== undefined) {
      setLoading(true)
      const loadingToastId=toast.loading("Exporting...",{
        containerId: "all_toast",
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: false,
      })
      onClick()
        .then((res) => {
          setLoading(false)
          toast.dismiss(loadingToastId)
          setTimeout(() => {
            csvInstance.current.link.click()
            if (res && onExportComplete) {
              onExportComplete();
            }
          }, 100)
        }).
        catch(err=>{
          setTimeout(() => {
            csvInstance.current.link.click()
          }, 100)
        })
    }
  }

  const iconButton = (
    <div
      onClick={() => onCsvClick()}
      className={`prime-table-toolbar__icon-btn ${loading ? "prime-table-toolbar__icon-btn--loading" : ""}`}
    >
      <FontAwesomeIcon icon={faFileExcel} />
    </div>
  )

  const defaultButton=(
    <div
      onClick={() => onCsvClick()}
      className={`btn btn-light bg-white shadow-sm btn-custom btn-sm text-primary ${loading ? "disabled" : ""}`}
    >
      <FontAwesomeIcon icon={faFileExcel} className="mr-2" />
      <span className="text-dark">{label}</span>
    </div>
  )

  const button = iconOnly ? iconButton : defaultButton;

  return (
    <div>
      {tooltip?
            <TooltipOverlay show={0} hide={0} title={tooltip} placement="bottom">
                {button}
            </TooltipOverlay>:button
      }
      <CSVLink
        ref={csvInstance}
        data={dataFormatted}
        filename={`${new Date().getTime()}.csv`}
        className="hidden"
      />
    </div>
  );
}

export default ExportCsvPrime